import React from 'react';
import {PATH_SCHOOLSHUB_SYSTEM_ADMIN} from '../../Router';

const SetupFormLayout = ({ children }) => (
  <div className="row">
    <div className="col-6 m-auto position-relative">
      <div className="mb-2">
        <a href={PATH_SCHOOLSHUB_SYSTEM_ADMIN} className="link-teal-to-gray font-14">
          Go back to login page
        </a>
      </div>
      <div className="box">
        {children}
      </div>
    </div>
  </div>
);

export default SetupFormLayout;
